import { useMutation, useQueryClient } from "@tanstack/react-query";
import { categoryApi } from "../services/category.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  CATEGORY_MESSAGES_ERROR,
  CATEGORY_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => categoryApi.enable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(CATEGORY_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(CATEGORY_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["categories-filter"] });
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
    onError: () => {
      errorNotification(CATEGORY_MESSAGES_ERROR.ENABLE_ERROR);
    },
  });
};

export const useDisableCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => categoryApi.disable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(CATEGORY_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(CATEGORY_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["categories-filter"] });
      queryClient.invalidateQueries({ queryKey: ["categories"] });
    },
    onError: () => {
      errorNotification(CATEGORY_MESSAGES_ERROR.DISABLE_ERROR);
    },
  });
};
